import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_API_KEYS',
  name: 'Workspace Api Keys',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  actions: ['CREATE'],
}

export default scope
